
import { defineComponent, type PropType } from "vue"

import type { MarketingArticleGateReadiness } from "packs/models/MarketingCampaign"

const MAX_VISIBLE = 5

// 基本3項目だけで記事提案を始めた場合に、OpenAI記事の公開前ゲート（対象ユーザー・状況・JTBD・検索意図・検討段階）で
// 止まることと不足項目を、提案・下書き作成の前に案内する。ゲートの条件は変えない。
export default defineComponent({
    name: "ArticleGateReadinessNotice",
    props: {
        readiness: { type: Object as PropType<MarketingArticleGateReadiness | null>, default: null },
    },
    computed: {
        visibleKeywords(): MarketingArticleGateReadiness["keywords"] {
            return (this.readiness?.keywords || []).slice(0, MAX_VISIBLE)
        },
        hiddenCount(): number {
            return Math.max(0, (this.readiness?.keywords || []).length - MAX_VISIBLE)
        },
    },
})
